import i18next from "i18next"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { AttachFileField } from "~/components/AttachFile/AttachFile"
import { Form } from "~/components/Form/Form"
import { FormSubmitSection } from "~/components/FormSubmitSection/FormSubmitSection"
import { FormInput } from "~/components/Input/Input"
import { RadioBundle } from "~/components/RadioBundle/RadioBundle"
import { FormSelect } from "~/components/Select/Select"
import { FormTextArea } from "~/components/TextArea/TextArea"
import { Theme } from "~/components/Theme/Theme"

import styles from "./index.module.css"

type FormWrapperProps = {
  excludeValidate?: string[]
}

export const FormWrapper: React.FC<FormWrapperProps> = ({ excludeValidate }) => {
  const { t } = useTranslation()
  const currLang = i18next.language
  const { appeals, code } = useApiContext("/formwithcontacts/list")

  useEffect(() => {
    console.log(appeals, code, "appeals,code")
  }, [appeals, code])

  const options: { [key: string]: string } = {
    "fin-results": t("ContactForm.Option.27"), // Вопросы по финансовым результатам
    "trade-questions": t("ContactForm.Option.15"), // Вопросы по сделкам
    "add-to-mailing": t("ContactForm.Option.18"), // Добавить в список рассылки
    "other": t("ContactForm.Option.19"), // Прочие вопросы IR

    "get-comment": t("ContactForm.Option.01"),
    "suggest-an-interview": t("ContactForm.Option.02"),
    "invite-speaker": t("ContactForm.Option.03"),
    "materials": t("ContactForm.Option.04"),
    "information-partnership": t("ContactForm.Option.05"),
    "strategic-issues": t("ContactForm.Option.06"),
    "sustainable-esg": t("ContactForm.Option.28"),

    "sustainable-report-esg": t("ContactForm.Option.29"),
    "social-partnership": t("ContactForm.Option.30"),

    "social-responsibility-and-esg": t("ContactForm.Option.07"),
    "stock-accounting": t("ContactForm.Option.08"),
    "general-meetings-of-shareholders": t("ContactForm.Option.09"),
    "dividends": t("ContactForm.Option.10"),
    "communication-channels-with-afk-sistema": t("ContactForm.Option.11"),
    "shareholder-meetings": t("ContactForm.Option.12"),
    "social-responsibility": t("ContactForm.Option.13"),
    "other-questions": t("ContactForm.Option.14"),
    "mass-media": t("ContactForm.Option.16"),
    "esg": t("ContactForm.Option.17"),
    "non-financial-reporting": t("ContactForm.Option.20"),
    "suggest-a-social-project": t("ContactForm.Option.21"),
    "charity": t("ContactForm.Option.22"),
    "cv": t("ContactForm.Option.23"),
    "otherHr": t("ContactForm.Option.24"),
    "send-resume": t("ContactForm.Option.25"),
    "internships": t("ContactForm.Option.26"),
  }

  const excludedOptionsOnEn = ["internships"]

  const filterAppeals = (appeals: string[] | undefined): string[] | undefined => {
    if (!appeals) {
      return []
    }

    const filtredAppeals: string[] = []

    for (const appeal of appeals) {
      if (!excludedOptionsOnEn.includes(appeal)) {
        filtredAppeals.push(appeal)
      }
    }

    return filtredAppeals
  }

  const appealsByLang = currLang === "en" ? filterAppeals(appeals) : appeals

  const selectOptions = appealsByLang?.map((appeal) => {
    return { label: options[appeal], value: appeal }
  })

  return (
    <Form
      className={styles.Form}
      excludeValidate={excludeValidate}
      initialValues={{
        ...(selectOptions?.length !== 0 ? { appeal: "" } : { appeal: "null" }),
        phone: "",
        email: "",
        name: "",
        message: "",
        organisation: "organisation",
        ...(!!code && { code }),
      }}
      url="/formwithcontacts/submit"
    >
      {selectOptions && selectOptions.length !== 0 && (
        <FormSelect
          className={styles.Field}
          name="appeal"
          options={selectOptions}
          placeholder={t("popup.Default.Form.Select.Placeholder")}
        />
      )}

      <FormInput
        className={styles.Phone}
        label={t("popup.Default.Form.Phone.Label")}
        name="phone"
      />

      <FormInput
        className={styles.Email}
        label={t("popup.Default.Form.Email.Label")}
        name="email"
      />

      <FormInput className={styles.Field} label={t("popup.Default.Form.Fio.Label")} name="name" />

      <RadioBundle className={styles.Field} />

      <FormTextArea
        className={styles.Field}
        label={t("popup.Default.Form.Message.Label")}
        name="message"
      />

      <Theme className={styles.Field} theme="light-blue">
        <AttachFileField />
      </Theme>

      <FormSubmitSection className={styles.SendWrapper} />
    </Form>
  )
}
